module.exports = __webpack_public_path__ + "static/media/icq.58539a91.wav";